import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { API_TIMEOUT_ERROR_MSG, API_TIME_OUT, SERVER_ERROR_MSG } from '../../common/const';
import { checkPng, createCropPos, noop } from '../../common/utils';
import { UploadStatus } from '../type/interface';
export function imageUploadRequest(opt) {
  var url = opt.url,
    request = opt.request,
    requestData = opt.requestData,
    onChange = opt.onChange,
    imageInfo = opt.imageInfo;
  var abortRef = {
    abort: noop
  };
  var abort = function abort() {
    return abortRef.abort();
  };
  onChange({
    status: UploadStatus.UPLOADING,
    index: imageInfo.index,
    abort: abort
  }, imageInfo);
  return request.post(url, requestData, {
    cancelToken: new request.CancelToken(function (cancel) {
      return abortRef.abort = cancel;
    }),
    timeout: API_TIME_OUT,
    timeoutErrorMessage: API_TIMEOUT_ERROR_MSG,
    withCredentials: true,
    showErrorToast: false
  }).then(function (res) {
    onChange({
      status: UploadStatus.SUCCESS,
      index: imageInfo.index,
      response: res
    }, imageInfo);
  }).catch(function (err) {
    if (request.isCancel(err)) {
      return;
    }
    onChange({
      index: imageInfo.index,
      status: UploadStatus.ERROR,
      errMsg: SERVER_ERROR_MSG
    }, imageInfo);
  });
}
export var getLocalFileRequestData = function getLocalFileRequestData(opt) {
  var croppedArea = opt.croppedArea,
    imageInfo = opt.imageInfo,
    uid = opt.uid;
  var cropPos = createCropPos(croppedArea.croppedAreaPixels, croppedArea.targetSize);
  var formData = new FormData();
  formData.append('file', imageInfo.file);
  formData.append('uid', uid);
  checkPng(imageInfo.fileType) && formData.append('png', 'true');
  Object.entries(cropPos).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      k = _ref2[0],
      v = _ref2[1];
    return formData.append(k, String(v));
  });
  return formData;
};
export var getUrlFileRequestData = function getUrlFileRequestData(opt) {
  var croppedArea = opt.croppedArea,
    imageInfo = opt.imageInfo,
    uid = opt.uid;
  var cropPos = createCropPos(croppedArea.croppedAreaPixels, croppedArea.targetSize);
  return _objectSpread(_objectSpread({}, cropPos), {}, {
    imageUrl: imageInfo.urlFile,
    uid: uid,
    png: checkPng(imageInfo.fileType)
  });
};